import { Link, useLocation, useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navbar } from 'react-bootstrap'

import { listDeployments } from '../../actions/tenantFinder'

const ChooseStateRedirector = () => {
  const stateData = useSelector(state => state.tenantFinder.data)
  const [searchTerm, setSearchTerm] = useState('')
  const dispatch = useDispatch()
  const params = useParams()

  useEffect(() => {
    dispatch(listDeployments())
  }, [])

  const handleSearchTermChange = e => {
    setSearchTerm(e.target.value)
  }
  const getRedirectPath = () => {
    if (params && params[0]) {
      return params[0]
    }

    return '/'
  }
  const filterStates = states => {
    if (!searchTerm?.length) {
      return null
    }

    // console.log(states)
    const filtered =
      states
        ?.filter(s => {
          const lcName = s.regionName.toLowerCase()
          const st = searchTerm.toLowerCase()
          const additional =
            s.regionId == 'DC' &&
            ('washington, d.c.'.includes(st) || 'washington, dc'.includes(st))

          return additional || lcName.includes(st)
        })
        .slice(0, 5) ?? []

    // console.log(searchTerm.toLowerCase(), filtered)
    return (
      <div className="state-drop-down">
        <ul>
          {filtered.map(c => (
            <li key={c.url}>
              <a href={`${c.defaultURL}${getRedirectPath()}`}>
                <div className="col-xs-5 col-sm-3">
                  <img style={{ maxHeight: '30px' }} src={c.logoJPG} />
                </div>
                <div className="col-xs-7 col-sm-9">
                  <h4 className="pull-left" style={{ lineHeight: '30px' }}>
                    {c.name}
                  </h4>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  if (!stateData?.result) {
    return null
  }

  const sortedStates = [...stateData?.result]?.sort((a, b) =>
    a.regionId.localeCompare(b.regionId)
  )
  const splat = getRedirectPath()

  return (
    <div>
      <Navbar collapseOnSelect={true} fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <img
                src="/images//images/assets/headed2/horizontal/dark.svg"
                style={{ height: '40px' }}
                alt="Headed2 Logo"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
      </Navbar>
      <div
        style={{ minHeight: '50vh', marginTop: '100px' }}
        onClick={() => setSearchTerm('')}>
        <div className="container">
          <h2 className="text-center">
            Did you know that the Headed2 CareerExplorer is available for all 50 states?
          </h2>
          <h3>
            Therefore, we first need to know which state you are connecting from so we can
            send you to the correct site.
          </h3>

          <div className="search-wrap" onClick={e => e.stopPropagation()}>
            <input
              className="input-lg form-control text-input"
              placeholder="Type your state or select from the list below"
              value={searchTerm}
              onChange={handleSearchTermChange}
            />
            {filterStates(sortedStates)}
          </div>
          {sortedStates.map(s => (
            <div
              key={`state-${s.regionId}`}
              style={{ width: '9%', padding: '5px', float: 'left' }}
              className="text-center">
              <a
                href={`${s.defaultURL}${splat}`}
                title={s.regionName}
                className="state-link"
                style={{ fontSize: '.8rem' }}>
                <img src={s.thumb} alt={`Logo for ${s.id}`} /> {s.regionId}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export { ChooseStateRedirector }
